import { useForm } from "react-hook-form";
import {
  ILoginFormModel,
  loginFormDefaultValues,
  loginFormSchema,
} from "../models/loginFormModel";
import { yupResolver } from "@hookform/resolvers/yup";

export const useLoginForm = () => {
  const form = useForm<ILoginFormModel>({
    defaultValues: loginFormDefaultValues,
    resolver: yupResolver(loginFormSchema),
  });

  return form;
};
